import { render, staticRenderFns } from "./location-filter.vue?vue&type=template&id=64f901f1&scoped=true"
import script from "./location-filter.vue?vue&type=script&lang=js"
export * from "./location-filter.vue?vue&type=script&lang=js"
import style0 from "./location-filter.vue?vue&type=style&index=0&id=64f901f1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f901f1",
  null
  
)

export default component.exports